<template>
  <footer class="footer">
    © 2026 |
    <el-popover placement="top" trigger="hover" :width="260">
      <img :src="kefuImg" alt="客服二维码" class="contact-img" />
      <template #reference>
        <a href="javascript:void(0)">联系我们</a>
      </template>
    </el-popover>
  </footer>
</template>

<script>
import kefuImg from '../image/kefu.jpg';
export default {
  name: 'FooterComponent',
  data() {
    return { kefuImg };
  }
};
</script>

<style scoped>
.footer {
  height: 38px;
  background: #fff;
  border-top: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 14px;
  margin-top: auto;
}
.footer a {
  color: var(--primary-color);
  margin: 0 8px;
  text-decoration: none;
  transition: color .2s ease;
}
.footer a:hover {
  color: var(--secondary-color);
}
.contact-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
}
</style>
